import Navbar from "@/components/LandingPage/Navbar";
import Footer from "@/components/LandingPage/Footer";
import { motion } from "framer-motion";

export default function Cookies() {
  return (
    <div className="bg-bg-primary min-h-screen flex flex-col">
      <Navbar />
      <main className="grow pt-32 pb-20 px-6">
        <div className="mx-auto max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-12"
          >
            <h1 className="font-display text-4xl sm:text-5xl mb-6 text-text-primary">
              Cookie <span className="text-ember">Policy</span>
            </h1>
            <p className="text-text-muted text-sm uppercase tracking-widest font-bold mb-8">
              Last Updated: March 26, 2026
            </p>
          </motion.div>

          <div className="prose prose-invert max-w-none text-text-muted leading-relaxed space-y-8">
            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                1. What are Cookies?
              </h2>
              <p>
                Cookies are small text files that are stored on your device when
                you visit most websites. They help the website remember your
                preferences and provide a more personalized browsing experience.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                2. How We Use Cookies
              </h2>
              <p>
                MineMe uses cookies to understand how you interact with our
                platform, remember your login state, and provide features such
                as your referral link persistence. We use both session cookies
                (which expire when you close your browser) and persistent
                cookies (which stay on your device for a set period).
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                3. Types of Cookies We Use
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Essential Cookies:</strong> Required for the platform
                  to function correctly.
                </li>
                <li>
                  <strong>Analytics Cookies:</strong> Help us improve the site
                  by tracking usage patterns.
                </li>
                <li>
                  <strong>Preference Cookies:</strong> Remember your settings
                  and UI preferences.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                4. Managing Cookies
              </h2>
              <p>
                Most web browsers allow you to control cookies through their
                settings. However, disabling essential cookies may impact your
                ability to use certain features of the MineMe platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-display text-text-primary mb-4">
                5. Updates to this Policy
              </h2>
              <p>
                We may update our Cookie Policy from time to time. We encourage
                you to review this page periodically to stay informed about our
                use of cookies and related technologies.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
